module.exports = __webpack_public_path__ + "static/media/default-user.339b3341.png";